import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './PageStyle.css';

function FailedPage() {

  const location = useLocation();
  const [language, setLanguage] = useState('EN');
  const [isGradient, setIsGradient] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const lang = searchParams.get('lang');
    if (!lang || (lang.toUpperCase() !== 'EN' && lang.toUpperCase() !== 'AR')) {
      return;
    }
    setLanguage(lang.toUpperCase());
  }, [location.search]);

  const handleLanguage = (event) => {
    const selectedLang = event.target.textContent.trim();
    setLanguage(selectedLang === 'English' ? 'EN' : 'AR');
    setIsGradient(selectedLang === 'English' ? true : false);
  };

  const gradientStyle = {
    background: isGradient
      ? 'linear-gradient(to right, rgba(103, 193, 98, 0.4) 50%, rgba(103, 193, 98, 1) 50%)'
      : 'linear-gradient(to left, rgba(103, 193, 98, 0.4) 50%, rgba(103, 193, 98, 1) 50%)',
  };


  return (
    <div className="Aa3">
      <div className='container'>
        <div className='header'>
          <div className='header-left'>
            <div className="language" style={gradientStyle} onClick={handleLanguage}>
              <div className='language-left'>
                <span>عربي</span>
              </div>
              <div className='language-middle'>
                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeWidth="2" d="M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M12,23 C15,23 16,18 16,12 C16,6 15,1 12,1 C9,1 8,6 8,12 C8,18 9,23 12,23 Z M2,16 L22,16 M2,8 L22,8"></path></svg>
              </div>
              <div className='language-right'>
                <span>English</span>
              </div>
            </div>
          </div>
          <div className='header-right'>
            <div className='logo'><img alt='Kid Security' src='%PUBLIC_URL%/../../kid-security-logo.png' /></div>
          </div>
        </div>
        <div className='form-content'>
          <div className='title'>
            <h4 id='headup-title'>{language === 'EN' ? 'Easy & secure' : 'سهل و آمن'}</h4>
          </div>
          <div className='form-content-top'>
            <div className='logo'><img alt='Kid Security' src='%PUBLIC_URL%/../../phone-icon.png' /></div>
          </div>
          <div className='form-content-middle'>
            <div className='title'>
              <h3 id='title'>{language === 'EN' ? 'Failed Operation.. try again later' : 'فشلت العملية.. حاول مرة أخرى لاحقاً'}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FailedPage;